import { eventBus, EVENTS } from './EventBus.js';
import API from './Api.js';
import './newAdv.js';
import './advutils.js';
import './function-adv.js';
// import cache from 'Cache.js';
let lastData=window.initialData;
window.posts = {};

const mainElem = '#rds-main';
// console.log('router 1');

function initPushNavigation() {
  window.onpopstate = function (event) {
    checkPage();
  };
}

function initNavigation() {
  // console.log('init navigation');
  $(document).on('click', 'a:not(.prevent_navigation)', function (e) {
    var href = $(this).attr('href');
    var target = $(this).attr('target');
    if (href == undefined) {
      return true;
    }
    var destination = href.split("#");
    if ((target != undefined && target == '_blank')) {
      return true;
    } else if (location.hostname != this.hostname) {
      e.preventDefault();
      e.stopPropagation();
      window.open(this.href, '_blank');
      return false;
    } else if ((destination[0] == "") && (destination[1])) {
      // console.log("a[name=" + destination[1] + "]");
      e.preventDefault();
      e.stopPropagation();
      $('html, body').animate({
        // scrollTop: $("a[name=" + destination[1] + "]").offset().top
        scrollTop: $("#" + destination[1]).offset().top - $('#sticky_nav').height()
      }, 500);
      const yOffsetForScroll = 80;
      const y = document.getElementById(destination[1]).getBoundingClientRect().top;
      const main = document.getElementById('rds-main');
      const header=document.getElementById('sticky_nav');
      main.scrollTo({
        top: y + main.scrollTop - main.getBoundingClientRect().top - yOffsetForScroll,
          behavior: 'smooth'
        });


      return true;
    }
    // OVERRIDE DEL METODO A HREF...
    e.preventDefault();
    e.stopPropagation();
    $("html, body").animate({ scrollTop: 0 }, 500);
    $("main").animate({ scrollTop: 0 }, 500);
    history.pushState({ page: location.href }, href, href);
    // //Verifico in locale
    // var source = $(this).data('source');
    // var eid = $(this).data('id');
    // var template = $(this).data('template');
    // loadCachePage(source, eid, template);
    checkPage();
  });
}



function replaceNavigation(href, callback) {
  history.replaceState({ page: location.href }, href, href);
  $("html, body").animate({ scrollTop: 0 }, 500);
  $("main").animate({ scrollTop: 0 }, 500);
  checkPage(callback);
}


function checkPage(callback, request, skipLoader) {
  var page = location.pathname + location.search;
  checkRemote(page, callback, request, skipLoader||false);
}

function checkPageNoLoader(page, callback, request){
  checkRemote(page, callback, request, true);
}

function elaboratePage(data) {
  var toreturn = false;
  try {
    if (data.status == 1) {
      //Verifico che esista il template
      if (window.templates[data.template]) {
        let template = window.templates[data.template];
        let temp = $('<div></div>');
        temp.append(template);
        if (data.breadcrumb && data.breadcrumb.length > 1) {
          temp.find('.no-breadcrumb').hide();
          temp.find('.with-breadcrumb').show();
          template = temp.html();
          template = addBreadcrump(template, data.breadcrumb);
        } else {
          temp.find('.with-breadcrumb').hide();
          temp.find('.no-breadcrumb').show();
          template = temp.html();
        }
        let htmlTemplate = replaceTemplate(template, data.content);
        htmlTemplate = removeTif(htmlTemplate);
        // $(mainElem).html(htmlTemplate);
        fillMain(htmlTemplate);

        if(data.blocks_to_hide) {
            for (let i = 0; i < data.blocks_to_hide.length; i++) {
                const block = data.blocks_to_hide[i];
                $(mainElem).find(`#${block}`).hide();
            }
        }

        if(data.content && data.content.gallery){
          window.gallery=data.content.gallery;
        }else{
          window.gallery=null;
        }
        replaceTemplateClass(data.template);
        const templateId=data.templateId||data.template;
        if (data.subtemplates) {
          $.each(data.subtemplates, function (index, value) {
            let subtemplate = index;
            if (value.length > 0) {
              $("#" + templateId + "-" + subtemplate).empty();
            }

            $.each(value, function (i, v) {
              if (window.templates[subtemplate]) {
                let html = replaceTemplate(window.templates[subtemplate], v);
                html = removeTif(html);
                $("#" + templateId + "-" + subtemplate).append(html);
              }
            });
          });
        }
      }


      toreturn = true;
    } else {
      fillMain(window.templates[404]);
      // $(mainElem).html(window.templates[404]);
      $("#overlay-wait").fadeOut();
    }

  } catch (e) {
    console.warn(e);
  } finally {
    $("#overlay-wait").fadeOut();
  }


  if (window.gaiframe) {
    try {
      var ifrpath = document.getElementById('atrframe').contentWindow.location.pathname;
      var nifrpath = "/atrds" + location.pathname;

      if (ifrpath == nifrpath) {
        //        console.log("Stesso path, non ricarico frame");
      } else {
        //        console.log("Path diverso, ricarico frame");
        //        document.getElementById('atrframe').src = "/atrds"+location.pathname;
        document.getElementById('atrframe').contentWindow.location.replace(nifrpath);
      }
    } catch (e) {
      console.warn(e);
    }
  }
  console.log('BLOCK REFRESH ', data.blockrefresh);
  //PageView analytics
  if (data.blockrefresh) {
    window.refresh_active = false;
  } else {
    window.refresh_active = true;
  }

  if (typeof data.content != 'undefined' && typeof data.content.tempo_di_refresh != 'undefined' && !isNaN(data.content.tempo_di_refresh)) {
    window.tempo_di_refresh = Number(data.content.tempo_di_refresh);
  } else {
    window.tempo_di_refresh = 2;
  }

  return toreturn;
}

function addBreadcrump(template, breadcrumbObj) {
  let linkColor = breadcrumbObj.length == 1 ? '' : 'opaque';
  let breadcrumbHtml = `
  <div class="flex align_center font_18 semi_bold">
    <img class="breadcrumb_arrow" src="https://media.rds.it/web/web-site-brandnew/svg/path-copy-3.svg"  role="presentation">
    <a href="${breadcrumbObj[0].url}" class="color_blue ${linkColor}">Torna a ${breadcrumbObj[0].label}</a>`;
  for (let i = 1; i < breadcrumbObj.length; i++) {
    linkColor = breadcrumbObj.length - 1 == i ? '' : 'opaque';
    const breadcrumbElement = breadcrumbObj[i];
    breadcrumbHtml += `<span class="color_blue">&nbsp;/&nbsp;</span>
    <a href="${breadcrumbElement.url}" class="color_blue ${linkColor}">${breadcrumbElement.label}</a>`;
  }

  breadcrumbHtml += `</div>`;
  let tmpl = $('<div></div>');
  tmpl.append(template);
  tmpl.find('.breadcrumb_container').html(breadcrumbHtml);
  return tmpl.html();
}

function replaceTemplate(template, values) {
  //console.log(template);
  if (values) {
    $.each(values, function (i, v) {
      var re = new RegExp("{{" + i + "}}", 'g');
      template = template.replace(re, v);
    });
  }

  //Eccezioni
  template = template.replace('<iframe src="/video/{{video_amazon}}"></iframe>', '');
  template = template.replace('it-rds-wpadmin.eu-west-1.elasticbeanstalk.com/wp-content/uploads/', 'media.rds.it/web/wp-content/uploads/');
  template = template.replace('www.rds.it/wp-content', 'media.rds.it/web/wp-content');
  template = template.replace('it-rds-wpadmin.eu-west-1.elasticbeanstalk.com', 'media.rds.it/web');
  template = template.replace('contenuti.rds.it', 'media.rds.it/web');
  template = template.replace('contenuti.rds.it/wp-content/uploads/', 'media.rds.it/web/wp-content/uploads/');

  return template;
}

function removeTif(template) {
  let temp = $('<div></div>');
  temp.append(template);
  const conds = $(temp).find('.rds-conditional');
  if (conds.length) {
    let cond = $(conds[0]).attr('t-if');
    if (cond && (cond.indexOf('{{') != -1 || cond.indexOf('null') != -1)) {
      conds[0].remove();
    } else {
      $(conds[0]).removeClass('rds-conditional');
      $(conds[0]).removeAttr('t-if');
    }
    return removeTif(temp.html());
  } else {
    return template;
  }
}

function checkRemote(page, callback, request, skipLoader) {
  if(!skipLoader){
    eventBus.emit(EVENTS.SHOW_LOADING);
  }


  if (!page) {
    page = location.pathname + location.search;
  }

  if(page.lastIndexOf('/') == page.length-1){
    page = page.substring(0, page.length-1)
  }

  try {
    if (window.navigationRequest) {
      window.navigationRequest.abort();
    }
  } catch (e) {
    console.warn(e);
    eventBus.emit(EVENTS.HIDE_LOADING);
  }
  let _request = request|| {};
  if(!_request.method){
      _request.method = 'get';
  }
  if(!_request.data){
      _request.data = null;
  }
   if(page=='/podcast/il-meglio-di-rds'){
    window.history.pushState("", "", '/il-meglio-di-rds');
    page='/il-meglio-di-rds';
  }
  if(skipLoader){
    const _data=Object.assign({},lastData);
    _data.refresh=true;
    eventBus.emit(EVENTS.PAGE_AFTER_RENDERING, _data);
    eventBus.emit(EVENTS.HIDE_LOADING);
    return;
  }
  window.navigationRequest =API[_request.method]('site' + page, _request.data, (data) => {
    lastData=data;
    let robots = document.getElementsByName('robots');
    if (location.hostname == 'rds.it' || location.hostname == 'www.rds.it'){
      if (robots.length == 0){
        if (!!data.content && data.content.noindex){
          let meta_elem = document.createElement('meta');
          meta_elem.name = 'robots';
          meta_elem.content = 'noindex nofollow';
          document.head.append(meta_elem);
        }
      }else{
        robots[0].remove();
      }
    }else{
      if (robots.length == 0){
        let meta_elem = document.createElement('meta');
        meta_elem.name = 'robots';
        meta_elem.content = 'noindex nofollow';
        document.head.append(meta_elem);
      }
    }

    console.log('location',location);
    replaceMetadata(data.metadata);
    importJavascript(data.template).then(() => {
      eventBus.emit(EVENTS.PAGE_BEFORE_LOADING, data.template);
      // getAdvRule(page, getDeviceType()).then(rule => {
      //   console.log(rule);
      // });
      if (elaboratePage(data)) {
        // if (data.template != 'post') {
        //     storePage(page, data);
        // }
        if (typeof callback === "function") {
          callback();
        }
        if (typeof window[data.jsfunction] === "function") {
          window[data.jsfunction](data);
        }
        eventBus.emit(EVENTS.PAGE_AFTER_RENDERING, data);
        eventBus.emit(EVENTS.HIDE_LOADING);
        showSections();
      }
    });

  });
}

function fillMain(template){
  $(mainElem).children().not('.always-in-page').remove();
  $(mainElem).prepend(template);
}

function isSmartphone() {
  if ($(window).width() < 768) {
    return true
  } else {
    return false
  }
}
function isTabletPortrait() {
  if ($(window).width() >= 768 && $(window).width() < 1024) {
    return true
  } else {
    return false
  }
}
function isTabletLandscape() {
  if ($(window).width() >= 1024 && $(window).width() < 1280) {
    return true
  } else {
    return false
  }
}
function isTabletLandscapeSkin() {
  if ($(window).width() >= 1024 && $(window).width() <= 1280) {
    return true
  } else {
    return false
  }
}
function isDesktop() {
  if ($(window).width() >= 1280 && $(window).width() < 1600) {
    return true
  } else {
    return false
  }
}
function isDesktopSkin() {
  if ($(window).width() > 1281 && $(window).width() < 1600) {
    return true
  } else {
    return false
  }
}
function isDesktopWideSkin() {
  if ($(window).width() >= 1600) {
    return true
  } else {
    return false
  }
}
function isDesktopWide() {
  if ($(window).width() >= 1600) {
    return true
  } else {
    return false
  }
}

function findScrollableParent(element) {
  let isBody,
    hasScrollableSpace,
    hasVisibleOverflow;
  do {
    element = element.parentElement;
    // set condition variables
    isBody = element === document.body;
    hasScrollableSpace = element.clientHeight < element.scrollHeight;
    hasVisibleOverflow = getComputedStyle(element, null).overflow === 'visible';
  } while (!isBody && !(hasScrollableSpace && !hasVisibleOverflow));
  return element;
}



class Router {
  init() {
    // console.log('router init');
    initPushNavigation();
    initNavigation();
  }
  addNavigation(href, callback, request) {

    eventBus.emit(EVENTS.SHOW_LOADING);

    //se il menù è aperto, chiudo il menu
    // if ($("#rds-section-menu").is(":visible") == true) {
    //   $('#rds-header-menu').attr('src', 'https://media.rds.it/web/web-site/header/icona-menu.svg');
    //   $('#rds-header-menu-text').html("MENU");
    //   $("#rds-section-menu").hide();
    //   $("#rds-section-main").show();
    //   $(".adv_skin").show();
    // }
    //    console.log("Pushstate 1 ");
    history.pushState({ page: location.href }, href, href);
    // try {
    //   fbq('track', 'ViewContent');
    // } catch (e) { }
    $("html, body").animate({ scrollTop: 0 }, 500);
    $("main").animate({ scrollTop: 0 }, 500);
    checkPage(callback, request);
  }
}


window.replaceNavigation = replaceNavigation;
window.checkPage = checkPageNoLoader;
window.checkPageReal = checkPage;

const router = new Router();
window.addNavigation = router.addNavigation;
export default router;


